<div id="container" class="p-grid p-md-10 p-md-offset-1 p-sm-12">
    <div class="p-md-4 p-sm-12">
        <p-card header="Car Rental Management System" subheader="Java, SpringBoot, Angular" styleClass="ui-card-shadow">
            <p-header>
                <iframe width="100%" height="215" 
                        src="https://www.youtube.com/embed/MeIucv2xru4" frameborder="0" 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </p-header>
            <div class="cardText">
            In this video, I show a demo about Car Rental Management System, a web application for a car rental business.
            The technologies I used to develop this application, were <i>Spring Boot, Angular 8, PrimeNG, PostgresSQL and git</i>.
            <a [routerLink]="['/work/car-rental']" routerLinkActive="true">Read more...</a>
            </div>
        </p-card>
    </div>
    <div class="p-md-4 p-sm-12">
        <p-card header="MyFEUT" subheader="Java, SpringBoot, Angular" styleClass="ui-card-shadow">
            <p-header>
                <iframe width="100%" height="215" 
                        src="https://www.youtube.com/embed/JUGLqg-LJJU" frameborder="0" 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </p-header>
            <div class="cardText">
            In this video, I show how I have developed a web application designed and based on the way that Faculty of Economy, University 
            of Tirana, Albania is organized. To develop this application, I used <i>Spring Boot and Angular 8, as well as PostgreSQL, PrimeNG and git. </i>
            <a [routerLink]="['/work/my-feut']" routerLinkActive="true">Read more...</a>
            </div>
        </p-card>
    </div>
    <div class="p-md-4 p-sm-12">
        <p-card header="GIF Weirdness Calculator" subheader="Angular, Typescript" styleClass="ui-card-shadow ">
            <p-header>
                <iframe width="100%" height="215" 
                        src="https://www.youtube.com/embed/mFEkv0OLeCA" frameborder="0" 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </p-header>
            <div class="cardText">Did you know that every GIF has a weirdness indicator? That's what I use to calculate your weirdness based on the GIFs you like.
                You select 5 GIFs with different weirdness levels as you like them to be and at the end, I present you with your weirdness score.
                <a [routerLink]="['/work/gif-weirdness-calculator']" routerLinkActive="true">Read more...</a>
            </div>
        </p-card>
    </div>
    <div class="p-md-4 p-sm-12">
        <p-card header="Space Game" subheader="Javascript, Node.js" styleClass="ui-card-shadow">
            <p-header>
                <iframe width="100%" height="215" 
                        src="https://www.youtube.com/embed/-QmodzBHIQs" frameborder="0" 
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </p-header>
            <div class="cardText">It is a difficult time as we are all in lockdown, but it is a good time to work on some side projects.
                    In order to practice my skills in <i>Javascript and Node.js</i>, I decided to develop the Space Battle game.
                    <a [routerLink]="['/work/space-game']" routerLinkActive="true">Read more...</a>
            </div>
        </p-card>
    </div>
</div>
<div class="fb-like p-md-10 p-md-offset-1 p-sm-12" data-href="https://lejdiprifti.web.app/work" data-width="" data-layout="standard" data-action="recommend" data-size="small" data-share="true"></div>
